File list

<ul>
  <li *ngFor="let file of files">
    {{ file }}
  </li>
</ul>
